const breakpoints = {
  xs: 0,
  sm: 544,
  md: 768,
  lg: 1024,
  xl: 1280
};
export default breakpoints;
